import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const land_postings: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'land_postings',
  dataType: 'land_postings',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Land Postings',
  description: 'Upcoming land sales in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'land_postings',
    type: LayerType.Polygon,
    style: {
      color: `hsla(205, 100%, 50%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      minzoom: 6,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/land_postings/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/land_postings/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'land_postings',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/land_postings',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'agreement_id',
      'tracts',
      'status',
      'pn_agreement_type',
      'expiry_date',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'land_postings',
    dataType: 'land_postings',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
